import { IListFetcher } from '../fetchers/IListFetcher';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { IContentInfo } from '../models/IContentInfo';
import { Module } from '../Module';
import { ExploreContentRequest } from '../ServerApi/requests/ExploreContentRequest';
import { ExploreFavoritedContentForUserRequest } from '../ServerApi/requests/ExploreFavoritedContentForUserRequest';
import { GetContentForUserRequest } from '../ServerApi/requests/GetContentForUserRequest';
import { ILeafFilterClause } from '../ServerApi/types/IFilterClause';
import { FetcherFactory } from '../services/FetcherFactory';
import { ResourceQuery } from './ResourceQuery';
import { ExploreFavoriteContentForUserRequest } from '../ServerApi/requests/ExploreFavoriteContentForUserRequest';

export class Content {

  public static $inject = ['FetcherFactory'];

  private exploreContentFetcher: IListFetcher<IContentInfo>;
  private exploreFavoritedContentForUser: IListFetcher<IContentInfo>;
  private exploreFavoriteContentForUser: IListFetcher<IContentInfo>;
  private getContentForUserFetcher: IListFetcher<IContentInfo>;

  constructor(FetcherFactory: FetcherFactory) {
    this.exploreContentFetcher = FetcherFactory.getServerResourceFetcher(ExploreContentRequest, ServerApiMapper.content);
    this.exploreFavoritedContentForUser = FetcherFactory.getServerResourceFetcher(ExploreFavoritedContentForUserRequest, ServerApiMapper.content);
    this.exploreFavoriteContentForUser = FetcherFactory.getServerResourceFetcher(ExploreFavoriteContentForUserRequest, ServerApiMapper.favoriteFromCrass);
    this.getContentForUserFetcher = FetcherFactory.getServerResourceFetcher(GetContentForUserRequest, ServerApiMapper.content);
  }

  public forProject(projectId: string, additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.exploreContentFetcher)
      .withExtraParams({ 'project': projectId })
      .withFilters(additionalFilterClauses);
  }

  public forUser(userId: string, additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.getContentForUserFetcher)
      .withExtraParams({ 'userId': userId })
      .withFilters(additionalFilterClauses);
  }

  public forFavorites(additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.exploreFavoritedContentForUser)
      .withFilters(additionalFilterClauses);
  }

  public forFavoritesFromCRASS(additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.exploreFavoriteContentForUser)
      .withFilters(additionalFilterClauses);
  }

  public forCurrentUser(additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.getContentForUserFetcher).withFilters(additionalFilterClauses);
  }

}

Module.instance().service('Content', Content);
